// extracted by mini-css-extract-plugin
module.exports = {"button":"FhRiq5","size-xs":"_1gzpSC","size-s":"_3glKpA","size-m":"_28X1kN","size-l":"_1aQaqG","pre-xs":"_3vipYF","pre-s":"_2feECv","pre-m":"_1vwB6u","pre-l":"_2Nqiz1"};